import { z } from "zod/v4"
import { createBrowserStore } from "@myvp/shared/src/functions/create-browser-store"

export const sharedDevToolsStore = createBrowserStore({
  key: "myvp-sharedDevToolsStore",
  initialValue: null,
  schema: z.enum(["tanstack", "react-query"]).nullable().catch(null),
  storage: localStorage,
})
